import {
  // primaryColor,
  whiteColor,
  blackColor,
  grayColor,
  hexToRgb,
  grayBoxShadow, // Import grayBoxShadow
} from "assets/jss/material-dashboard-pro-react.js";

const customSelectStyle = (theme, clientColor) => ({
  select: {
    padding: "12px 0 7px",
    fontSize: ".75rem",
    fontWeight: "400",
    lineHeight: "1.42857",
    textDecoration: "none",
    textTransform: "uppercase",
    // color: grayColor[2],
    letterSpacing: "0",
    "&:not(.Mui-disabled)": {
      color: grayColor[2],
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
    "&[aria-owns] + input + svg": {
      transform: "rotate(180deg)",
    },
    "& + input + svg": {
      transition: "all 300ms linear",
    },
  },
  selectFormControl: {
    margin: "7px 0 17px 0 !important",
    "& > div": {
      "&:before": {
        borderBottomWidth: "1px !important",
        borderBottomColor: grayColor[4] + "!important",
      },
      "&:after": {
        borderBottomColor: clientColor + "!important",
      },
    },
  },
  selectLabel: {
    fontSize: "12px",
    textTransform: "uppercase",
    // color: grayColor[2] + " !important",
    top: "8px",
    "&:not(.Mui-disabled)": {
      color: grayColor[2] + " !important",
    },
  },
  selectMenu: {
    "& > div > ul": {
      border: "0",
      padding: "3px 0",
      margin: "0",
      boxShadow: "none",
      minWidth: "100%",
      borderRadius: "4px",
      boxSizing: "border-box",
      display: "block",
      fontSize: "14px",
      textAlign: "left",
      listStyle: "none",
      backgroundColor: whiteColor,
      backgroundClip: "padding-box",
    },
    "& $selectPaper $selectMenuItemSelectedMultiple": {
      backgroundColor: "inherit",
    },
    "& > div + div": {
      maxHeight: "300px !important",
    },
  },
  selectMenuItem: {
    fontSize: "13px",
    // padding: "10px 20px",
    padding: "0 30px 0 10px",
    // margin: "0 5px",
    margin: "0 3px",
    borderRadius: "2px",
    transition: "all 150ms linear",
    display: "block",
    clear: "both",
    fontWeight: "400",
    lineHeight: "2",
    whiteSpace: "nowrap",
    // paddingRight: "30px",
    "&:hover": {
      backgroundColor: clientColor,
      opacity: "0.8",
      color: whiteColor + " !important",
      ...grayBoxShadow, // Changed from primaryBoxShadow
    },
    "&:not(.unavailable)": {
      color: grayColor[7],
    },
    "&.unavailable": {
      color: grayColor[4],
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  selectMenuItemSelected: {
    color: whiteColor + " !important",
    backgroundColor: clientColor + "!important",
    "&.unavailable": {
      opacity: "0.55",
    },
  },
  selectMenuItemSelectedMultiple: {
    color: whiteColor + " !important",
    backgroundColor: "transparent !important",
    "&:hover": {
      backgroundColor: clientColor + "!important",
      color: whiteColor,
      ...grayBoxShadow, // Changed from primaryBoxShadow
      "&:after": {
        color: whiteColor,
      },
    },
    "&:after": {
      top: "16px",
      right: "12px",
      width: "12px",
      height: "5px",
      borderLeft: "2px solid currentColor",
      transform: "rotate(-45deg)",
      opacity: "1",
      color: grayColor[2],
      position: "absolute",
      content: "''",
      borderBottom: "2px solid currentColor",
      transition: "opacity 90ms cubic-bezier(0,0,.2,.1)",
    },
    "&.unavailable": {
      opacity: "0.55",
    },
  },
  selectPaper: {
    boxSizing: "borderBox",
    borderRadius: "4px",
    padding: "0",
    minWidth: "100%",
    display: "block",
    border: "0",
    boxShadow: "0 2px 5px 0 rgba(" + hexToRgb(blackColor) + ", 0.26)",
    backgroundClip: "padding-box",
    margin: "2px 0 0",
    fontSize: "14px",
    textAlign: "left",
    listStyle: "none",
    backgroundColor: "transparent",
    maxHeight: "266px",
  },
});

export default customSelectStyle;
